import { render, staticRenderFns } from "./EditPoint.vue?vue&type=template&id=2d3005be&scoped=true"
import script from "./EditPoint.vue?vue&type=script&lang=js"
export * from "./EditPoint.vue?vue&type=script&lang=js"
import style0 from "./EditPoint.vue?vue&type=style&index=0&id=2d3005be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3005be",
  null
  
)

export default component.exports